export default "__VITE_ASSET__CkbN10B4__"